<div class="px-3">

  <div class="rem-text-default mb-6">
    <div class="flex align-items-end">

      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-users font-medium text-xl"></i>
      </div>
      <div>
        <div class="text-2xl font-medium">Payments By Channel</div>
        <div class="text-right mt-2">Analyze the data of payments by channel of a creditor</div>
      </div>
      
    </div>
  </div>


 <div class="flex flex-wrap justify-content-between">
    <div class="flex flex-row gap-3">
      <creditor-autocomplete
        (onSelect)="onSelectCreditor($event)"
      ></creditor-autocomplete>
      <p-floatLabel>
         <p-calendar id="startDate"
                     [(ngModel)]="fromDate"
         />
         <label for="startDate">From Date</label>
      </p-floatLabel>

      <p-floatLabel>
         <p-calendar id="startDate"
                     [(ngModel)]="toDate"
           />
         <label for="startDate">To Date</label>
      </p-floatLabel>

    </div>

   <div class="flex gap-2">
       <remitter-button
          (click)="onGenerate()" 
          label='Generate'
          icon='play'
          severity="secondary"
          [disabled]="isGenerateButtonDisabled"
      />     
      
      <remitter-button
          (click)="onExport()" 
          label='Export'
          icon='file-export'
          [disabled]="isGenerateButtonDisabled"
        />
   </div>
</div>
<div class="mt-4">
     <div 
     *ngIf="!hasTableData && hasClickedSearch"
      style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
                    🚫 No results for {{ selectedCreditorCompanyName }}
      </div>

    <p-table
        *ngIf="hasTableData"
        [value]="results" 
        [paginator]="true"
        [rows]="5"
        [tableStyle]="{ 'min-width': '50rem' }"
        [rowsPerPageOptions]="[5, 10, 20]">
        <ng-template pTemplate="header">
            <tr class="text-xs">
                <th>Integration Link Id</th>
                <th>Notification Status</th>
                <th>Notification Type</th>
                <th>Occurred At </th>
                <th>Paid On</th>               
                <th>Transaction Type</th>       
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-result>
            <tr class="text-xs">
                <td>{{ result.integrationLinkId }}</td>
                <td>{{ result.notificationStatus }}</td>
                <td>{{ result.notificationType }}</td>
                <td>{{ result.occurredAt | date: 'MMMM d, y' }}</td>  
                <td>{{ result.paidOn | date: 'MMMM d, y' }}</td>  
                <td>{{ result.transactionType }}</td>       
            
            </tr>
        </ng-template>
    </p-table>
</div>

</div>



